import styled from "styled-components";

import { colors } from "../../../../../assets";

export const InfoModalButtonContainer = styled.div`
  .modal-mask {
    background: ${colors["background-modal"]};
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    opacity: 0;
    pointer-events: none;
    display: grid;
    place-items: center;
    transition: opacity 0.2s ease-in;
  }

  .modal-mask.show-modal {
    opacity: 1;
    pointer-events: auto;
  }

  .modal-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: 0;
    cursor: initial;
  }

  .modal-content {
    box-shadow: rgba(0, 0, 0, 0.05) 0px 4px 20px;
    width: 80%;
    max-width: 900px;
    max-height: 80vh;
    overflow-y: scroll;
    position: relative;
    padding: 50px;
    background: #fff;
    border-radius: 3px;
    transition: all 0.3s ease-in;
  }

  .modal-btn-container {
    position: sticky;
    top: 0;
  }

  .modal-close-btn {
    background: none;
    border: none;
    padding: 0;
    width: 24px;
    position: absolute;
    top: -20px;
    right: -20px;
    cursor: pointer;
  }

  .button-link {
    background: none;
    border: none;
    padding: 0;
    display: flex;
    align-items: center;
    color: ${colors["PR-001-100"]};
    font-size: 18px;
    line-height: 18px;
    font-weight: 700;
    text-transform: uppercase;
    cursor: pointer;

    &-image {
      width: 40px;
    }
  }
`;